import React from "react";
import "./App.css";

import "@smarthtmlelements/smart-elements/source/modules/smart.datetimepicker.js";

declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      "smart-date-time-picker": any;
    }
  }
}

const App: React.FC = () => {
  return (
    <div className="App">
      <smart-date-time-picker calendar-button enable-mouse-wheel-action drop-down-position="center-bottom" spin-buttons spin-buttons-position="left"></smart-date-time-picker>
    </div>
  );
}

export default App;
